module.exports = __webpack_public_path__ + "img/2.06e3e36a.gif";